export default __webpack_public_path__ + "static/media/onboarding_demo_v002_compressed.9687cb31.mp4";